import React from "react";
import { Page, View, Text, Image, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    display: "flex",
    justifyContent: "center", // Centers vertically
    alignItems: "center", // Centers horizontally
    backgroundColor: "#FFFFFF",
    height: "100%", // Ensures full page height
    padding: 20,
  },
  section: {
    display: "flex",
    alignItems: "center", // Centers horizontally
    textAlign: "center", // Aligns text content
  },
  title: { fontSize: 20, marginBottom: 10, fontWeight: "bold" },
  sub_title: { fontSize: 14, color: "#6c757d" },
});

const FirstPagePdf = ({ data }) => {
  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <Image
          src={data.logo}
          style={{
            width: 200,
            height: "auto",
            objectFit: "contain",
            maxHeight: 100,
          }}
        />
        <Text style={styles.title}>{data.title}</Text>
        {data?.sub_title && (
          <Text style={styles.sub_title}>{data.sub_title}</Text>
        )}
      </View>
    </Page>
  );
};

export default FirstPagePdf;
